import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const ReturnPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/">
          <Button variant="ghost" className="mb-6">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold mb-2">Return Policy</h1>
          <p className="text-gray-600 mb-8">Effective Date: {new Date().toLocaleDateString()}</p>

          <div className="space-y-6 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Return Window</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li><strong>Most Items:</strong> 30 days from delivery date</li>
                <li><strong>Baby Clothes & Toys:</strong> 14 days from delivery</li>
                <li><strong>Perishable Items (Fruits & Drinks):</strong> Not returnable (see refund policy)</li>
                <li><strong>Diapers:</strong> 30 days if unopened</li>
                <li><strong>Clothing:</strong> 14 days with tags attached</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Return Conditions</h2>
              <p className="mb-2">Items must be:</p>
              <ul className="list-disc ml-6 space-y-2">
                <li>Unused and in original condition</li>
                <li>In original packaging with all tags attached</li>
                <li>Include all accessories and manuals</li>
                <li>Not damaged or altered in any way</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">3. How to Return</h2>
              <ol className="list-decimal ml-6 space-y-2">
                <li>Contact us at <a href="mailto:support@dresspay.com" className="text-indigo-600 hover:underline">support@dresspay.com</a> or call <a href="tel:3464837337" className="text-indigo-600 hover:underline">346-483-7337</a></li>
                <li>Provide your 5-digit order confirmation code</li>
                <li>We'll send you a prepaid return label (for defective items only)</li>
                <li>Pack the item securely in original packaging</li>
                <li>Drop off at nearest shipping location</li>
                <li>You'll receive a tracking number for your return</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Return Shipping Costs</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li><strong>Defective/Incorrect Items:</strong> FREE (we provide prepaid label)</li>
                <li><strong>Change of Mind:</strong> Customer pays return shipping</li>
                <li><strong>Wrong Size/Color:</strong> Customer pays return shipping</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Non-Returnable Items</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>Perishable goods (fruits, drinks, food items)</li>
                <li>Personal care items that have been opened</li>
                <li>Intimate apparel or underwear</li>
                <li>Gift cards or digital products</li>
                <li>Final sale or clearance items</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Inspection & Processing</h2>
              <ul className="list-disc ml-6 space-y-2">
                <li>Returns are inspected within 2-3 business days of receipt</li>
                <li>If approved, refund is processed to your original payment method</li>
                <li>Refund appears in 5-10 business days depending on your bank</li>
                <li>If return doesn't meet conditions, item may be sent back to you</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Exchanges</h2>
              <p>We currently don't offer direct exchanges. To get a different item:</p>
              <ol className="list-decimal ml-6 space-y-2 mt-2">
                <li>Return the original item for refund</li>
                <li>Place a new order for the item you want</li>
              </ol>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">8. International Returns</h2>
              <p>For international orders:</p>
              <ul className="list-disc ml-6 space-y-2 mt-2">
                <li>Customer is responsible for all return shipping costs</li>
                <li>Customs duties and import taxes are non-refundable</li>
                <li>Allow 3-4 weeks for international return processing</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-gray-900">9. Contact Us</h2>
              <ul className="list-none ml-0 space-y-1">
                <li><strong>Email:</strong> <a href="mailto:support@dresspay.com" className="text-indigo-600 hover:underline">support@dresspay.com</a></li>
                <li><strong>Phone:</strong> <a href="tel:3464837337" className="text-indigo-600 hover:underline">346-483-7337</a></li>
                <li><strong>Hours:</strong> Monday - Friday, 9 AM - 6 PM EST</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;